import React, { useEffect, useState } from "react";
import Layout from "../../common/Layout";
import "./index.scss";
import Auto from "../../assets/tesla_x.svg";
import { Link } from "react-router-dom";
import axios from "axios";
import { url } from "../../utils/config";
import { useData } from "../../utils/dataProvider";

export default function ModelChoose() {
  const [data, setData] = useState(null);

  const [carId, setCarId] = useState(null);
  const { setAuto } = useData();
  useEffect(() => {
    setAuto(null);
    axios.get(url + "/cars").then((res) => {
      setData(res.data);
    });
  }, []);
  if (data) {
    return (
      <>
        <div className="formular">
          <div className="formular-headline">Wählen Sie Ihr Fahrzeug:</div>
          {data.map((cars, index) => (
            <div key={cars.id} className="model-list">
              <div className="model-list-title">{cars.name}</div>
              <div className="modal-list-blocks">
                {cars.cars.map((car, idx) => (
                  <div
                    key={car.id}
                    className={`model-block ${car.ID == carId ? "aktiv" : ""}`}
                    onClick={() => setCarId(car.ID)}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <img src={car.image}></img>
                      <div className="model-name">{car.name}</div>
                    </div>
                    <div className="choose"></div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        {carId ? (
          <Link className="btn" to={`/model/${carId}`}>
            <div>Weiter zum Tarif</div>
          </Link>
        ) : (
          <div className="btn" style={{ opacity: 0.5 }}>
            Weiter zum Tarif
          </div>
        )}
      </>
    );
  }
}
